<template>
  <div class="home">
    <div class="content" v-show="info.is_sel && info.is_share">
      <img :src="info.base_img" alt="">
      <div class="p-btn">
        <button @click="showPop">生成祝福海报</button>
      </div>
      <div v-show="false" class="canv">
        <canvas id="mycanvas" width="310" height="652"></canvas>
        <div id="qr"></div>
      </div>
      <van-popup
      v-model:show="info.show"
      closeable
      position="bottom"
    >
      <div class="pop-box">
          <h1>填写信息</h1>
          <div class="form-box">
            <!-- <div class="flex-box">
              <div class="f-l">
                输入兑换码
              </div>
                <input v-model="info.code" placeholder="请输入兑换码"  onkeyup="value=value.replace(/[^\w\.\/]/ig,'')" maxlength="20" class="f-r" type="text">
            </div> -->
            <div class="flex-box">
              <div class="f-l">
                祝福对象
              </div>
                <input v-model="info.name" placeholder="请输入祝福对象" maxlength="6" class="f-r" type="text">
            </div>
            <div class="flex-box">
              <div class="f-l">
                选择性别
              </div>
              <div class="f-r">
                <van-radio-group v-model="info.checked" @change="changeXb" direction="horizontal">
                  <van-radio name="1">先生</van-radio>
                  <van-radio name="2">女士</van-radio>
                </van-radio-group>
              </div>
            </div>
            <div class="flex-btn">
              <button class="b-l" @click="toSelectImg">选择背景图片</button>
              <button @click="shareReport" class="b-r">生成祝福海报</button>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
    <div class="select-img" v-show="!info.is_sel && info.is_share">
        <div class="flex-img-box">
            <div class="img-box" v-for="(item, index) in img_list" :key="item.id">
                <img @click="selectImg(item.url, index)" :src="item.url" alt="" />
            </div>
        </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { onMounted, reactive, watch } from "vue"; 
import { onBeforeRouteUpdate, useRoute  } from "vue-router";
import QRCode from "qrcodejs2";
import router from "../router";
import { Toast } from "vant";
export default {
  name: 'Home',
  setup() {
      onBeforeRouteUpdate ((from, to, next) => {
        console.log(from, to, next);
      })
      const info = reactive({
        is_share: true,
        show: false,
        checked: "1",
        is_sel: true,
        code: "",
        name: "",
        sex: "先生",
        shareImg: "",
        qrUrl: "",
        is_canvas: false,
        base_img: require("../assets/images/share1.png"),
        base_index: 0,
      });
      const img_list = reactive([
        {
          id: 1,
          url: require("../assets/images/share1.png")
        },
        {
          id: 2,
          url: require("../assets/images/share2.png")
        },
        {
          id: 3,
          url: require("../assets/images/share3.jpg")
        },
        {
          id: 4,
          url: require("../assets/images/share4.png")
        },
        {
          id: 5,
          url: require("../assets/images/share5.png")
        },
        {
          id: 6,
          url: require("../assets/images/share6.png")
        },
        {
          id: 7,
          url: require("../assets/images/share7.png")
        },
        {
          id: 8,
          url: require("../assets/images/share8.png")
        }
      ])
      const route = useRoute()
      const query = route.query;
      if (query.info) {
        info.is_share = false
      }
      watch(() => route.path,() => {
        console.log('监听到变化', route.path)
        window.location.href = location.href;
      })
      const showPop = () => {
        info.show = true;
      };
      const selectImg = (url, index) => {
        info.base_img = url;
        info.base_index = index;
        info.is_sel = true;
      };
      const toSelectImg = () => {
        info.is_sel = false;
      };
      const shareReport = () => {
        let name = info.name.trim()
        if(!name || name == "") {
          Toast("请输入祝福对象");
          return false;
        } else {
          doDraw();
        }
      };
      const changeXb = (e) => {
        if(e == 1) {
          info.sex = "先生";
        } else {
          info.sex = "女士";
        }
      };
      
      const doDraw = () => {
        var canvas = document.getElementById("mycanvas");
        var ctx = canvas.getContext("2d");
        var ratio = getPixelRatio(ctx);  // 关键代码
        // canvas.style.width = canvas.width + 'px';
        // canvas.style.height = canvas.height + 'px';
        canvas.width = 310 * ratio;
        canvas.height = 652 * ratio;
        ctx.scale(ratio, ratio);
        // 放大倍数
        console.log(canvas.width, canvas.height)
        let imgBg = new Image();
        imgBg.src = info.base_img;
        imgBg.onload = function() {
          ctx.drawImage(imgBg, 0, 0, 310, 552);
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 552, 310, 100); 
          let temp_h = 20;
          ctx.font = `bold 15px OPPOSans`;
          if(info.code) {
            ctx.fillText("兑换码： " + info.code , 14, 540);
            // temp_h = 20;
          }
          ctx.font = `bold 20px OPPOSans`;
          ctx.fillStyle = "#000000";
          ctx.fillText("祝：" + info.name + info.sex, 19, 572 + temp_h);
          ctx.fillText("生日快乐！", 116, 607 + temp_h);

          // ctx.strokeStyle = "#ffffff";
          // ctx.strokeText("生日快乐！", 19*ratio, (520 + temp_h)*ratio);
          info.shareImg = canvas.toDataURL();
          let tem_query =  {
              checked: info.checked,
              name: info.name,
              sex: info.sex,
              base_index: info.base_index
            }
          if(query.info) {
            console.log(query.info);
            tem_query.is_share = true;
          } else {
            Toast("海报生成成功");
          }
          sessionStorage.setItem("shareImg", info.shareImg);
          setTimeout(() => {
            // info.is_canvas = false;
            router.push({
              path: "/resultPage",
              query: {
                info: JSON.stringify(tem_query)
              }
            })
          }, 1000);     
          // let img2 = new Image();
          // img2.src = info.qrUrl;
          // img2.onload = function() {
          //   ctx.fillStyle = "#ffffff";
          //   ctx.fillRect(204*ratio, 471*ratio, 72*ratio, 72*ratio); 
          //   ctx.drawImage(img2, 210*ratio, 477*ratio, 60*ratio, 60*ratio);
          //   info.shareImg = canvas.toDataURL();
          //   localStorage.setItem("shareImg", info.shareImg);
          //   router.push("/resultPage")
          // }
        }
      };
      onMounted(() => {
        let a = false;
        if(query.info) {
          let temp_info = JSON.parse(query.info);
          info.name = temp_info.name;
          info.base_index = temp_info.base_index;
          info.checked = temp_info.checked;
          info.sex = temp_info.sex;
          info.base_img = img_list[temp_info.base_index].url
          doDraw();
        }
        if(a) {
          getQr();
        }
      });

      function getPixelRatio(context) {
        var backingStore = context.backingStorePixelRatio ||
          context.webkitBackingStorePixelRatio ||
          context.mozBackingStorePixelRatio ||
          context.msBackingStorePixelRatio ||
          context.oBackingStorePixelRatio ||
          context.backingStorePixelRatio || 1;
        return (window.devicePixelRatio || 1) / backingStore;
      }
        // 画二维码
      const getQr = () => {
        let id = document.getElementById("qr");
        new QRCode(id, {
          text: "http://10.10.2.44:8080/",
          width: 80,
          height: 80,
          colorDark: "#000000",
          colorLight: "#ffffff",
          iconBorderColor: "#FFFFFF",
          correctLevel: QRCode.CorrectLevel.H,
        });
        var mycanvas1 = document.getElementsByTagName("canvas")[1];
        info.qrUrl = convertCanvasToImage(mycanvas1);
      };
      const convertCanvasToImage = (canvas) => {
        // var image = new Image(); // canvas.toDataURL 返回的是一串Base64编码的URL，当然,浏览器自己肯定支持 // 指定格式 PNG
        let src = canvas.toDataURL("image/png");
        return src;
      };
      return { info, showPop, img_list, selectImg, toSelectImg, shareReport, changeXb };
  }
}
</script>

<style lang="stylus">
  .home {
    width: 100%;
    height: 100vh;
    overflow-y: scroll;
    padding-bottom: 30px;
    img {
      width: 100%;
    }
    .p-btn {
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 42px;
      z-index: 6;
      text-align: center;
      button {
        display: inline-block;
        width: 232px;
        height: 68px;
        background: rgba(0, 0, 0, 0.7);
        border-radius: 8px;
        font-size: 28px;
        font-family: OPPOSans, OPPOSans-Medium;
        font-weight: 500;
        color: #ffffff;
        border: none;
      }
    }
    .select-img {
      padding: 3px 30px;
      box-sizing: border-box;
      .flex-img-box {
        display: -webkit-flex;
        display: flex;
        -webkit-justify-content: space-between;
        justify-content: space-between;
        -webit-flex-wrap: wrap;
        flex-wrap: wrap;
        .img-box {
          font-size: 0;
          -webkit-flex: 0 0 48%;
          flex: 0 0 48%;
          margin-top: 27px;
          img {
            width: 100%;
          }
        }
      }
    }
  }
  .pop-box {
    h1 {
      height: 95px;
      line-height: 95px;
      text-align center;
      font-size: 32px;
      font-family: OPPOSans, OPPOSans-Bold;
      font-weight: 700;
      color: #333333;
    }
    .form-box {
      padding: 0 40px;
      box-sizing: border-box;
      .flex-box {
        margin-top: 20px;
        background: #f8f8f8;
        display: -webkit-flex;
        display: flex;
        border-radius: 24px;
        .f-l {
          width: 184px;
          padding-left: 24px;
          box-sizing: border-box;
          line-height: 96px;
          color: #333333;
          font-size: 28px;
          font-weight: 400;
          text-align: left;
          position: relative;
        }
        .f-l:before {
          position: absolute;
          content: "";
          width: 1px;
          height: 30px;
          background: #e5e5e5;
          right: 0;
          top: 33px;
          z-index 2;
        }
        .f-r {
          -webkit-flex: 1;
          flex: 1;
          height: 96px;
          border: none;
          background: #f8f8f8;
          padding: 0 20px;
          box-sizing: border-box;
          font-size: 28px;
          font-family: OPPOSans, OPPOSans-Medium;
          font-weight: 500;
          text-align: left;
          color: #333333;
          .van-radio-group--horizontal {
            height: 100%;
            width: 80%;
            justify-content: space-between;
            .van-radio__icon {
              font-size: 26px;
              .van-icon {
                line-height: 1.25em;
              }
            }
            .van-radio__label {
              font-size: 28px;
              font-family: OPPOSans, OPPOSans-Medium;
              font-weight: 500;
              color: #333333;
            }
          }
        }
      }
      .flex-btn {
        display: -webkit-flex;
        display: flex;
        justify-content: space-between;
        padding: 20px 36px;
        box-sizing: border-box;
        button {
          width: 248px;
          height: 76px;
          opacity: 1;
          border-radius: 8px;
          font-size: 28px;
          font-family: OPPOSans, OPPOSans-Medium;
          font-weight: 500;
          color: #ffffff;
          border: none;
        }
        .b-l {
          background: #3f9bf0;
        }
        .b-r {
          background: #ee6f1e;
        }
      }
    }
  }
  .van-toast__text {
    font-size: 28px;
    padding: 10px 20px;
  }
</style>